document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-bf-menu-toggle]');
  if (menuToggle) {
    const panel = document.getElementById(menuToggle.getAttribute('aria-controls'));
    const isOpen = panel?.classList.toggle('open');
    menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    return;
  }

  const opener = event.target.closest('[data-bf-modal-open]');
  if (opener) {
    event.preventDefault();
    const modal = document.getElementById('bf-modal-' + opener.dataset.bfModalOpen);
    modal?.showModal();
    return;
  }

  const closer = event.target.closest('[data-bf-modal-close]');
  if (closer) {
    closer.closest('dialog')?.close();
    return;
  }

  const chatToggle = event.target.closest('[data-bf-chat-toggle]');
  if (chatToggle) {
    const panel = document.getElementById('bf-chat-panel');
    const isOpen = panel?.classList.toggle('open');
    chatToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    return;
  }

  const chatCloser = event.target.closest('[data-bf-chat-close]');
  if (chatCloser) {
    document.getElementById('bf-chat-panel')?.classList.remove('open');
    document.querySelector('[data-bf-chat-toggle]')?.setAttribute('aria-expanded', 'false');
    return;
  }

  if (event.target.tagName === 'DIALOG' && event.target.hasAttribute('open')) {
    const rect = event.target.getBoundingClientRect();
    const inDialog =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;
    if (!inDialog) event.target.close();
    return;
  }

  // Click outside the chat widget closes the panel — it's a plain div, not
  // a <dialog>, so it doesn't get native light-dismiss like the modals above.
  const chatWidget = document.querySelector('.bf-chat-widget');
  const chatPanel = document.getElementById('bf-chat-panel');
  if (chatPanel?.classList.contains('open') && chatWidget && !chatWidget.contains(event.target)) {
    chatPanel.classList.remove('open');
    document.querySelector('[data-bf-chat-toggle]')?.setAttribute('aria-expanded', 'false');
  }
});

// bareform PDP gallery: Dawn's product-info.js only knows how to swap images
// inside a <media-gallery> component. Our bf-product.liquid template uses a
// hand-built gallery instead, so we mirror the freshly-rendered main image
// from the variant-change AJAX response ourselves.
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event?.data?.sectionId;
    const newHtml = event?.data?.html;
    if (!sectionId || !newHtml) return;

    const currentImg = document.getElementById(`bf-pdp-main-img-${sectionId}`);
    const newImg = newHtml.getElementById(`bf-pdp-main-img-${sectionId}`);
    if (!currentImg || !newImg) return;

    if (newImg.srcset) currentImg.srcset = newImg.srcset;
    currentImg.src = newImg.src;
    if (newImg.alt) currentImg.alt = newImg.alt;
  });
});

// Fit Finder quiz: a 4-step wizard inside snippets/bf-fit-quiz-modal.liquid.
// Answers live in module state (not the DOM) so the size calc stays simple;
// the DOM is just re-painted from that state on every interaction.
(function () {
  const quiz = { band: null, bust: null, size: null, fit: null, style: null };
  let quizStep = 1;

  function quizModal() {
    return document.getElementById('bf-modal-fit-quiz');
  }

  function paintQuiz() {
    const modal = quizModal();
    if (!modal) return;

    modal.querySelectorAll('[data-quiz-step]').forEach((el) => {
      el.classList.toggle('active', el.dataset.quizStep === String(quizStep));
    });
    modal.querySelectorAll('[data-quiz-dot]').forEach((dot) => {
      dot.classList.toggle('active', Number(dot.dataset.quizDot) <= (quizStep === 'result' ? 4 : quizStep));
    });

    const backBtn = modal.querySelector('[data-quiz-back]');
    if (backBtn) backBtn.style.visibility = quizStep === 1 ? 'hidden' : 'visible';

    const label = modal.querySelector('[data-quiz-step-label]');
    if (label) {
      label.textContent = quizStep === 'result' ? 'Your result' : `Question ${quizStep} of 4`;
    }

    if (quizStep === 'result') {
      const sizeEl = modal.querySelector('[data-quiz-result-size]');
      const copyEl = modal.querySelector('[data-quiz-result-copy]');
      const ctaEl = modal.querySelector('[data-quiz-result-cta]');
      if (sizeEl) sizeEl.textContent = quiz.size || 'M';
      if (copyEl) {
        const fitPhrase = quiz.fit === 'Soft & relaxed' ? 'soft, second-skin comfort' : 'a snug, supportive hold';
        const styleLabel = quiz.style || 'bras';
        copyEl.innerHTML = `Based on a ${quiz.band || ''} band and ${quiz.bust || ''} bust, size <strong>${quiz.size || 'M'}</strong> is your closest match. Since you like ${fitPhrase}, start with our ${styleLabel} in ${quiz.size || 'M'}.`;
      }
      if (ctaEl) ctaEl.textContent = 'Shop ' + (quiz.style || 'Bras');
    }
  }

  function resetQuiz() {
    quiz.band = null; quiz.bust = null; quiz.size = null; quiz.fit = null; quiz.style = null;
    quizStep = 1;
    const modal = quizModal();
    modal?.querySelectorAll('.bf-quiz-chip.selected').forEach((chip) => chip.classList.remove('selected'));
    paintQuiz();
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-bf-modal-open="fit-quiz"]');
    if (opener) {
      resetQuiz();
      return;
    }

    const bandChip = event.target.closest('[data-quiz-band]');
    if (bandChip) {
      quiz.band = bandChip.dataset.quizBand;
      bandChip.parentElement.querySelectorAll('.bf-quiz-chip').forEach((c) => c.classList.remove('selected'));
      bandChip.classList.add('selected');
      quizStep = 2;
      paintQuiz();
      return;
    }

    const bustChip = event.target.closest('[data-quiz-bust]');
    if (bustChip) {
      quiz.bust = bustChip.dataset.quizBust;
      quiz.size = bustChip.dataset.quizSize;
      bustChip.parentElement.querySelectorAll('.bf-quiz-chip').forEach((c) => c.classList.remove('selected'));
      bustChip.classList.add('selected');
      quizStep = 3;
      paintQuiz();
      return;
    }

    const fitChip = event.target.closest('[data-quiz-fit]');
    if (fitChip) {
      quiz.fit = fitChip.dataset.quizFit;
      fitChip.parentElement.querySelectorAll('.bf-quiz-chip').forEach((c) => c.classList.remove('selected'));
      fitChip.classList.add('selected');
      quizStep = 4;
      paintQuiz();
      return;
    }

    const styleChip = event.target.closest('[data-quiz-style]');
    if (styleChip) {
      quiz.style = styleChip.dataset.quizStyle;
      styleChip.parentElement.querySelectorAll('.bf-quiz-chip').forEach((c) => c.classList.remove('selected'));
      styleChip.classList.add('selected');
      quizStep = 'result';
      paintQuiz();
      return;
    }

    const back = event.target.closest('[data-quiz-back]');
    if (back) {
      if (quizStep === 'result') quizStep = 4;
      else if (typeof quizStep === 'number' && quizStep > 1) quizStep -= 1;
      paintQuiz();
      return;
    }

    const restart = event.target.closest('[data-quiz-restart]');
    if (restart) {
      resetQuiz();
      return;
    }
  });
})();
